// src/config/wsAccountCheckerConfig.js (New File)

export const WS_ACCOUNT_CHECKER_TYPES = {
  // Client -> Server
  START_CHECK: 'ACCOUNT_CHECK_START',
  CANCEL_CHECK: 'ACCOUNT_CHECK_CANCEL',
  GET_HISTORY: 'ACCOUNT_CHECK_GET_HISTORY', // New

  // Server -> Client
  CHECK_INITIATED: 'ACCOUNT_CHECK_INITIATED',
  CHECK_PROGRESS: 'ACCOUNT_CHECK_PROGRESS',
  CHECK_RESULT: 'ACCOUNT_CHECK_RESULT',
  CHECK_BATCH_RESULT: 'ACCOUNT_CHECK_BATCH_RESULT',
  CHECK_NO_RESULTS: 'ACCOUNT_CHECK_NO_RESULTS',
  CHECK_COMPLETED: 'ACCOUNT_CHECK_COMPLETED',
  CHECK_ERROR: 'ACCOUNT_CHECK_ERROR',
  HISTORY_LIST: 'ACCOUNT_CHECK_HISTORY_LIST', // New
  HISTORY_ERROR: 'ACCOUNT_CHECK_HISTORY_ERROR', // New
};

export const WS_ACCOUNT_CHECKER_TOPICS = {
  USER_QUEUE_BASE: '/user/queue/account-checker',
  RESULTS: '/results',
  ERRORS: '/errors',
  APP_GET_HISTORY: '/get-history', // Correct app endpoint path
  USER_HISTORY: '/history',       // Correct user queue path

  APP_ENDPOINT: '/account-checker' // Base app endpoint
};